import React from 'react';
import styled from 'styled-components';

import {
  getFirstName,
  typeToReadableSEOType,
  generateImageFromCDN,
  formatLocation,
} from '../helpers';

import Avatar from './Avatar';

const Wrapper = styled.div`
  background: ${p => p.theme.primary100};
  padding: 8px 6px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Info = styled.div`
  color: ${p => p.theme.primary1000};
  text-align: right;
  margin-right: 14px;
  font-size: 14px;
`;

const Name = styled.div`
  margin-bottom: 6px;
`;

const TextStatus = styled.div`
  color: #849f93;
  font-size: 12px;
  font-weight: lighter;
`;

export default function VendorChatCard({ vendor }) {
  return (
    <Wrapper>
      <Info>
        <Name>
          {getFirstName(vendor.contact)} -{' '}
          {typeToReadableSEOType(vendor.type, false)}
        </Name>
        <TextStatus>Receiving Messages</TextStatus>
      </Info>
      <Avatar vendor={vendor} size={50} showStatusIndicator={true} />
    </Wrapper>
  );
}
